




























import { computed, defineComponent, ref } from '@vue/composition-api';
import { useAllResources } from '../../store/modules/resources';
import StratificationDetails from './StratificationDetails.vue';

export default defineComponent({
	components: {
		StratificationDetails,
	},
	props: {
		stratificationId: {
			required: true,
			type: String,
		},
	},
	setup(props, { root }) {
		const { isLoading } = useAllResources(root.$store);
		const stratification = computed(() =>
			root.$store.getters['resources/getStratificationById'](props.stratificationId)
		);
		const field = computed(() => root.$store.getters['resources/getFieldByAreaId'](stratification.value.object));
		const area = computed(() => root.$store.getters['resources/getAreaById'](stratification.value.object));
		const locations = computed(() => root.$store.getters['resources/getLocationsByFieldId'](field.value.id));
		const isDialogVisible = ref<boolean>(false);

		const handleClick = () => {
			isDialogVisible.value = true;
		};

		return {
			isLoading,
			handleClick,
			isDialogVisible,
			field,
			area,
			locations,
			stratification,
		};
	},
});
